import { useFetchOne } from '@/hooks/useFetchOne';
import type { Account } from '@/models/account/types';
import { fetchAccountInfo } from '@/models/account/service';

export function useAccountController(idAccount: string | undefined) {
  return useFetchOne<Account>(idAccount ? () => fetchAccountInfo(idAccount) : undefined);
}
